import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { DataWidgetComponent } from './data-widget.component';
import { MobileAppPtiRanking } from '../models/mobileAppPtiRanking';

@Component({
  template: `<risk-heat-meter
    [risk]="risk"
    version="v4"
    (interact)="openInsight($event)"
  ></risk-heat-meter> `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RiskPillOnlyComponent
  extends DataWidgetComponent
  implements OnInit
{
  @Input()
  data: MobileAppPtiRanking;
  risk: string;

  ngOnInit(): void {
    super.ngOnInit();
    this.risk = this.data[this.key];
  }
}
